import cn from 'classnames';
import { Transition } from '@headlessui/react';

const FinalAnswer = ({ isShowing, setStep }) => (
  <Transition
    show={isShowing}
    enter="transition-all ease duration-150"
    enterFrom="opacity-0 scale-50"
    enterTo="opacity-100 scale-100"
    leave="transition-all ease duration-150"
    leaveFrom="opacity-100 scale-100"
    leaveTo="opacity-0 scale-50"
    afterEnter={() => {
      setTimeout(() => {
        setStep(2);
      }, 2000);
    }}
  >
    <div className="flex justify-end">
      <div className="flex space-x-2">
        <div
          className={cn(
            'px-2.5 py-1 rounded-xl w-fit bg-neutral-900 border border-neutral-600  transition-opacity text-right'
          )}
        >
          LLMs are not always truthful or aligned with human preferences.
        </div>
        <img
          className="inline-block w-6 h-6 rounded-full ring-2 ring-neutral-600"
          src="/static/images/icons/llm-1.png"
          alt=""
        />
      </div>
    </div>
  </Transition>
);

export default FinalAnswer;
